module.exports = __webpack_public_path__ + "static/media/test15_4.c95ef6fd.png";